import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import Button from "../../../components/common/Button/Button";
import FormInput from "../../../components/common/FormInput/FormInput";
import UploadImage from "../../../components/common/UploadImage/UplaodImage";
import { showToast } from "../../../components/common/ToastNotification/ToastNotification";

import { getFeatureshowId,updateFeatureList } from "../../../api/service/custompage.service";

const UpdateFeature = () => {
  const navigate = useNavigate();
  const { id } = useParams(); 

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    page_id: "",
    page_feature_id: "",
    name: "",
    description: "",
    slug: "",
  });

  const [images, setImages] = useState([]);
  const [existingImage, setExistingImage] = useState(null);


  useEffect(() => {
    fetchFeature();
  }, []);

  const fetchFeature = async () => {
    try {
      const res = await getFeatureshowId(id);

      if (res.success) {
        const data = res.data;

        setFormData({
          page_id: data.page_id,
          page_feature_id: data.id,
          name: data.name,
          description: data.description,
          slug: data.slug,
        });
        if (data.icon?.url) {
          setExistingImage(data.icon.url);
        }
      }
    } catch (error) {
      showToast.error("Failed to fetch feature details");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleFileSelect = (file) => {
    const preview = URL.createObjectURL(file);

    setImages([
      {
        file,
        preview,
      },
    ]);
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.name.trim()) {
    showToast.error("Please enter feature name");
    return;
  }

  if (!formData.description.trim()) {
    showToast.error("Please enter feature description");
    return;
  }

  try {
    setLoading(true);

    const submitData = new FormData();
    submitData.append("page_id", formData.page_id);
    submitData.append("page_feature_id", formData.page_feature_id);
    submitData.append("name", formData.name.trim());
    submitData.append("description", formData.description.trim());
    submitData.append("slug", formData.slug);


    if (images.length > 0 && images[0]?.file) {
      submitData.append("icon", images[0].file);
    }



    const response = await updateFeatureList(submitData);

    if (response.success) {
      showToast.success("Feature updated successfully");
      navigate(-1);
    } else {
      showToast.error(response.message || "Update failed");
    }
  } catch (error) {
    console.error("Update error:", error);
    showToast.error("Update failed");
  } finally {
    setLoading(false);
  }
};


  return (
    <>
      <div className="d-flex gap-2 align-items-center mb-3">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
        <h3 className="management-tile mb-0 ml-2">Update Feature</h3>
      </div>

      <form onSubmit={handleSubmit}>
        <Row>
          <Col xs={12} className="mb-3">
            <label className="form-label">
              Feature Name <span style={{ color: "red" }}>*</span>
            </label>
            <FormInput
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </Col>

          <Col xs={12} className="mb-3">
            <label className="form-label">
              Description <span style={{ color: "red" }}>*</span>
            </label>
            <FormInput
              type="textarea"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              rows={4}
              required
            />
          </Col>

          <Col xs={12} className="mb-3">
            <label className="form-label">Icon</label>

            <UploadImage
              onFileSelect={handleFileSelect}
              existingImages={existingImage}
            />
          </Col>

          <Col xs={12}>
            <Button type="submit" disabled={loading}>
              {loading ? "Updating..." : "Update Feature"}
            </Button>
          </Col>
        </Row>
      </form>
    </>
  );
};

export default UpdateFeature;
